import CuttingEdgeMedia from './CuttingEdgeMedia'

export default CuttingEdgeMedia
